import I from '../types.ts';

const getPages: I['getPages'] = function () {
    const { shortList, pageUrl } = this.state;
    const { levels } = this.props;

    if (pageUrl) {
        return [{ key: pageUrl }];
    }

    if (shortList) {
        const url = levels[2] || shortList[0]?.url;

        if (url) {
            return [{ key: url }];
        }
    }

    return [];
};

export default getPages;
